export default {
  methods: {
    validateValue(rules, value){
      if(typeof rules === 'function'){
        return rules.apply(this, [value])
      }
      let errors = []
      for (let method in rules) {
        let params = rules[method]
        let valid
        if (Array.isArray(params)) {
          valid = this.validate[method](value, ...params)
        } else {
          valid = this.validate[method](value, params)
        }
        if(!valid){
          errors.push(this.friendlyError({method: method, params: params}))
        }
      }
      if (errors.length === 0){
        return {result: true, errors: errors}
      } else {
        return {result: false, errors: errors}
      }
    },
    validateFields(){

    },
    validateInput(input){
      let validation = input.dataset.validate.split(/\|/)
      let validationMethod = validation.shift()
      let valid = this.validate[validationMethod](input.value, ...validation)
      return valid
    },
    friendlyError (error) {
      let message = ''
      let method = error.method
      let params = error.params
      switch(method){
        case 'string':
          if (typeof params[1] !== 'undefined') {
            message = `Please enter between ${params[0]} and ${params[1]} characters`
          } else {
            message = `Please enter at least ${params[0]} characters`
          }
        break;
        case 'required':
          message = 'Required field'
          break;
        case 'regex':
          message = params[2]
          break;
        default:
          message = 'Invalid field'
        break
      }
      return message
    }
  },
  computed: {
    validate () {
      return {
        required (value, message) {
          if (typeof value === "undefined" || value === null) {
            return false
          } else if (typeof value === 'string'  && value.trim() === '') {
            return false
          } else {
            return true
          }
        },
        string(str, min, max) {
          if (!str || typeof str === 'undefined') {
            if (min === 0) {
              return true
            } else {
              return false
            }
          }
          let valid = true
          if(str.length < min){
            valid = false
          }
          if(typeof max !== 'undefined' && str.length > max){
            valid = false
          }
          return valid;
        },
        regex(str, rx_match, rx_not, message) {
          if (!str || typeof str === 'undefined') {
            if (!rx_match){
              return true
            } else {
              return false
            }
          }
          let valid = true
          if (rx_match) {
            if (typeof rx_match === 'string'){
              rx_match = new RegExp(rx_match)
            }
            if(!str.match(rx_match)){
              valid = false
            }
          }
          if (rx_not) {
            if (typeof rx_not === 'string') {
              rx_not = new RegExp(rx_not)
            }
            if(str.match(rx_not)){
              valid = false
            }
          }
          return valid
        }
      }
    }
  }
}